/* CHOICE-style product page enhancements:
   - move the quantity stepper into the buy row (beside ADD TO CART)
   - add a green "Buy now" button (add to cart → checkout)
   Re-applied after Dawn re-renders the product form (variant change). */
(function () {
  function buyNow(btn) {
    // Submit the REAL product <form> (BUY NOW lives inside it), so the current
    // variant, quantity, selling_plan (subscriptions), line-item properties and
    // gift-card recipient are all included — then go straight to checkout.
    // FormData also collects controls outside the form that reference it via the
    // `form=` attribute, matching exactly what the native ADD TO CART submit sends.
    var form = btn.closest('form') || document.querySelector('product-form form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value || idInput.disabled) return; // unavailable / sold out
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '…';
    // NB: no Content-Type header — the browser sets the multipart boundary for FormData.
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          // Add rejected (sold out, or a required field/selling plan missing).
          btn.disabled = false;
          btn.textContent = label;
          return;
        }
        window.location.href = root + 'checkout';
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  function enhance() {
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons) return;

    // 1. Quantity beside ADD TO CART
    var qty = document.querySelector('.product-form__quantity');
    if (qty && qty.parentElement !== buttons) {
      buttons.insertBefore(qty, buttons.firstChild);
    }

    // 2. Green "Buy now" button (once)
    if (!buttons.querySelector('.lux-buynow')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lux-buynow';
      btn.textContent = 'BUY NOW';
      btn.addEventListener('click', function () { buyNow(btn); });
      buttons.appendChild(btn);
    }
  }

  function init() {
    enhance();
    var info = document.querySelector('#ProductInfo') || document.querySelector('.product__info-container');
    if (info) {
      // Debounce: only re-apply AFTER Dawn's variant-change morph settles, never
      // during it — moving DOM mid-morph confuses Dawn's diff and duplicates the
      // variant pickers.
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(enhance, 200);
      }).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
